import React from "react";
import requestDemo from '../../static/request-demo.png';
import Footer from "../components/Footer";
import Heading from "../components/Heading";
import Layout from "../components/Layout";
import Navbar from "../components/Navbar";
import RequestDemoContent from "../components/request-demo/RequestDemoContent";
import SEO from "../components/SEO";

export default function RequestDemo() {
  return (
    <Layout>
      <SEO 
        title="Request demo | alooba.com"
        description="Book in a quick online demo now to see how Alooba can help you achieve your hiring goals in analytics."
      />
      <Navbar dark="true" />
      <Heading title="Request Demo"
        imageUrl={requestDemo} alt="Icon"
      />
      <RequestDemoContent />
      <Footer />
    </Layout>
  )
}
